import * as React from 'react';

export const renderChildren = <T extends {}>(children: React.ReactNode, props: T) => (
	<>
		{React.Children.map(children, (Component: React.ReactElement<T>) => (
			React.cloneElement(
				Component,
				props,
			)
		))}
	</>
);